export default __webpack_public_path__ + "static/media/blog-home-image.cddb53dc.webp";